import i18n from 'i18next';

export default ({ isInLiveMode, videoProperties, isChildLocale = false }) => {
  if (isChildLocale)
    return {
      summary: {
        type: 'TextArea',
        label: i18n.t('summary'),
        help: i18n.t('summary-field-description'),
      },
    };

  const {
    data: { general, topics },
  } = videoProperties;

  const breadcrumbsItems =
    (topics || []).length > 0
      ? topics.map(({ name, id }) => ({ text: name, key: id }))
      : [{ text: i18n.t('videos'), key: 'videos-home-page' }];

  breadcrumbsItems.push({ text: general?.name, key: breadcrumbsItems.length + 1 });

  return {
    exclude_from_search: {
      type: 'Boolean',
      label: i18n.t('search'),
      labelText: i18n.t('exclude-activity-from-search-results'),
    },
    ...(isInLiveMode
      ? {
          topic: {
            type: 'SelectTopic',
            label: i18n.t('topics'),
            help: i18n.t('add-topic-helper'),
          },
        }
      : {
          topics: {
            type: 'Breadcrumbs',
            label: i18n.t('topics'),
            help: i18n.t('change-topics-move-file-structure'),
            breadcrumbs: breadcrumbsItems,
          },
        }),
    summary: {
      type: 'TextArea',
      label: i18n.t('summary'),
      help: i18n.t('summary-field-description'),
    },
  };
};
